import React from 'react';
import { Tooltip } from 'antd';
import { TileWrapper, NameWrapper, ValueWrapper, MetricDivider } from './styled';

const Tile = ({ name, value, showDivider = true, tagKey = null }) => (
  <Tooltip placement="topLeft" title={tagKey}>
    <TileWrapper>
      <NameWrapper>{name}</NameWrapper>
      <ValueWrapper>{value}</ValueWrapper>
    </TileWrapper>
    {showDivider ? <MetricDivider /> : null}
  </Tooltip>
);

export default Tile;
